// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__2Fldm","btn":"Slider_btn__2rMK6","containerList":"Slider_containerList__2sBzB","list":"Slider_list__CN-T6"};